export default __webpack_public_path__ + "static/media/ic-trash.4db51bcc.svg";